import { NgModule } from '@angular/core';
import { IhmNotificationsService } from './services/ihm-notifications.service';
import { IhmNotificationsComponent } from './ihm-notifications.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule, MatIconModule, MatBadgeModule, MatCardModule, MatDividerModule, MatMenuModule],
  declarations: [IhmNotificationsComponent],
  exports: [IhmNotificationsComponent],
  providers: [IhmNotificationsService]
})
export class IhmNotificationsModule {}
